import type { HoursException } from '@/lib/hours';
import exceptions from './hours-exceptions.json';

export { WEEK_HOURS } from './week-hours';

/**
 * Bank holidays, Ramadan and Christmas variations. Edited through the CMS
 * (content/hours/exceptions.json) and validated into hours-exceptions.json by
 * scripts/build-content.mjs at build.
 */
export const HOURS_EXCEPTIONS: readonly HoursException[] = exceptions as HoursException[];
